import { useTranslation } from 'react-i18next'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'

export const EfiPaymentsFeaturesCard = () => {
    const { t } = useTranslation('processors')

    return (
        <Card className="mb-6">
            <CardHeader>
                <CardTitle>{t('supportedFeatures')}</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="space-y-4">
                    <div>
                        <h4 className="text-sm font-medium text-muted-foreground mb-2">{t('paymentProcessing')}</h4>
                        <ul className="list-disc pl-4 text-sm text-muted-foreground space-y-1">
                            <li>{t('efiPaymentsSecurePayments') || 'Secure Payments'}</li>
                            <li>{t('efiPaymentsFraudDetection') || 'Fraud Detection'}</li>
                            <li>{t('efiPaymentsRealtimeMonitoring') || 'Realtime Monitoring'}</li>
                            <li>{t('efiPaymentsRefunds') || 'Refunds'}</li>
                            <li>{t('efiPaymentsWebhooks') || 'Webhooks'}</li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="text-sm font-medium text-muted-foreground mb-2">{t('processorType')}</h4>
                        <div className="flex flex-wrap gap-2">
                            <Badge variant="outline">{t('efiPaymentsPaymentProcessing') || 'Payment Processing'}</Badge>
                            <Badge variant="outline">{t('efiPaymentsRefunds') || 'Refunds'}</Badge>
                            <Badge variant="outline">{t('efiPaymentsWebhooks') || 'Webhooks'}</Badge>
                        </div>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}

